import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchVisitBlocks = async (trialType, blockName) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (trialType) params.append("trial_type", trialType);
  if (blockName) params.append("block_name", blockName);

  const response = await axios.get(`${__API_URL__}/api/ecrf/get_visit_blocks/?${params}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetVisitBlocks = ({ trialType, blockName, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_blocks", trialType, blockName],
    queryFn: () => fetchVisitBlocks(trialType, blockName),
    enabled: enabled,
  });
};

export default useGetVisitBlocks;
